import * as React from 'react';
import ApplicationsService from '../../../services/ThirdPartyApplicationsService';
import AADAppsHome from '../AADAppsHome';

const AdAppsHome = () => {

	return (
		<AADAppsHome
			applicationsService={new ApplicationsService()}
			typeOfApps={"3rd Party Applications"}
		/>
	);
}

export default AdAppsHome;